import {GameStateEnums} from '../../../../../shared/GameEnums'
import {ActionsThatCanBeCancelled} from '@colonist/game-base-types'
import {PIXI} from '@colonist/pixi'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGameActionButtonView} from './UIGameActionButtonView'
import {UIGameCityImprovementProgressTrackerSquareView} from '../ui_game_cities_and_knights/UIGameCityImprovementProgressTrackerSquareView'
import {UIGameActionButtonMultiView} from './UIGameActionButtonMultiView'
import {ArrayUtils} from '../../../../../shared/utils/ArrayUtils'
import {EnumUtils} from '../../../../../shared/utils/EnumUtils'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {CityImprovementTypes, TurnState} from '@colonist/game-states'
import {MechanicValidatorCityImprovements} from '@colonist/game-mechanic-validators'

export class UIGameActionButtonViewCityImprovement extends UIGameActionButtonView implements UIGameMechanic {
    private readonly parentButton: UIGameActionButtonMultiView
    private readonly cityImprovement: CityImprovementTypes
    private readonly cityImprovementsValidator: MechanicValidatorCityImprovements

    constructor(uiGameManager: UIGameManager, container: PIXI.Container, cityImprovement: CityImprovementTypes, parentButton: UIGameActionButtonMultiView, cityImprovementsValidator: MechanicValidatorCityImprovements) {
        super(uiGameManager, cityImprovement, container)
        this.parentButton = parentButton
        this.cityImprovementsValidator = cityImprovementsValidator
        this.cityImprovement = cityImprovement

        const buttonIconW = this.width * 0.4
        const buttonIconX = (this.width - buttonIconW) / 2
        const buttonIcon = new UIGameCityImprovementProgressTrackerSquareView(buttonIconX, buttonIconX, buttonIconW, this, cityImprovement, 0)
        buttonIcon.setActiveTexture()
        this.addAsset(buttonIcon)

        this.setUpdateAction()
        this.stateUpdated()
        this.updateHoverForNewPurchasePrice()
        this.parentButton.checkAndUpdateOpacityIfExpandedButtonsAreActive()

        const improvementTypeKey = EnumUtils.getEnumKey(cityImprovement, CityImprovementTypes)
        this.setTip({key: `strings:game.cards.progress.title.${improvementTypeKey}`}, [{key: 'strings:colonistCommon.utils.emptyString'}])
    }

    buttonSpecificEvents(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CityImprovementStateUpdated:
            case UIGameEventEnums.PlayerControllerStateUpdated:
            case UIGameEventEnums.GameStateUpdated:
                this.stateUpdated()
                this.updateHoverForNewPurchasePrice()
                this.parentButton.checkAndUpdateOpacityIfExpandedButtonsAreActive()
                break
            default: break
        }
    }

    private setUpdateAction() {
        this.updateAction(() => {
            this.clickedCityUpgrade()
        })
    }

    private clickedCityUpgrade() {
        if(!this.canPerformBuyAction(this.cityImprovementsValidator.canPlayerUpgradeCity(this.uiGameManager.gameController.myColor, this.cityImprovement))) return
        this.uiGameManager.socketGameSend.confirmCityUpgrade(this.cityImprovement)
    }

    private updateHoverForNewPurchasePrice() {
        const costForNextUpgrade = this.cityImprovementsValidator.getCostForNextCityUpgradeForPlayerAndType(this.uiGameManager.gameController.myColor, this.cityImprovement)
        if(costForNextUpgrade == undefined) {
            this.setHoverAction([])
            return
        }
        this.setHoverAction(costForNextUpgrade)
    }

    private canPlayerTakeAction(): boolean {
        return this.cityImprovementsValidator.canPlayerUpgradeCity(this.uiGameManager.gameController.myColor, this.cityImprovement).canTakeAction
    }

    private stateUpdated() {
        this.inactivateOpacity()

        if(!this.uiGameManager.gameController.isMyTurn) return
        if(!this.canPlayerTakeAction()) return

        this.updateOpacityForTurnState()
    }

    private updateOpacityForTurnState() {
        if(!this.allowableTurnStates()) return
        if(!ArrayUtils.elementInArray(ActionsThatCanBeCancelled.actions, this.uiGameManager.gameController.currentState.actionState)) return
        this.activateOpacity()
        this.parentButton.activateOpacity()
    }

    private allowableTurnStates(): boolean {
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.Turn) return true
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.SpecialBuildPhase) return true

        return false
    }
}
